import { render, staticRenderFns } from "./PopupRiskInfo.vue?vue&type=template&id=65a5d21e&scoped=true"
import script from "./PopupRiskInfo.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfo.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfo.vue?vue&type=style&index=0&id=65a5d21e&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfo.vue?vue&type=style&index=1&id=65a5d21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a5d21e",
  null
  
)

export default component.exports